import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Ahora todo es más simple para mí. Tengo una rutina clara y mi piel lo agradece.',
  author: 'María L.'
}, {
  quote: 'Me ayudó a organizar mi rutina. Ya no me siento perdida con tantos productos.',
  author: 'Ana R.'
}, {
  quote: 'Me encanta lo fácil que es seguirlo. Simple, claro y efectivo.',
  author: 'Laura G.'
}];
export function Testimonials() {
  return <section className="py-24 bg-beige" data-id="element-105">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-107">
          <h2 className="text-4xl font-medium text-brown mb-4" data-id="element-108">
            Lo que dicen de la guía
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-109">
          {testimonials.map((test, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.15
        }} className="bg-white rounded-3xl p-8 shadow-sm flex flex-col" data-id="element-110">
              <div className="flex gap-1 mb-6 text-sage" data-id="element-111">
                {[...Array(5)].map((_, idx) => <Star key={idx} size={18} fill="currentColor" data-id="element-112" />)}
              </div>
              <p className="text-brown/80 font-light italic mb-8 flex-grow" data-id="element-113">
                "{test.quote}"
              </p>
              <p className="font-medium text-brown" data-id="element-114">— {test.author}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}